import type { CSSProperties } from 'react';

const LEFT_BOUNDARY_GRADIENT: string = 'linear-gradient(to right, var(--zen-fixed-left-shadow, transparent), transparent)';
const RIGHT_BOUNDARY_GRADIENT: string = 'linear-gradient(to left, var(--zen-fixed-right-shadow, transparent), transparent)';

export const FIXED_BOUNDARY_SHADOW_CLASSNAME: string = 'absolute top-0 bottom-0 pointer-events-none w-2';

export const getFixedBoundaryStyle = (fixed: 'left' | 'right'): CSSProperties => ({
  [fixed]: '100%',
  background: fixed === 'left' ? LEFT_BOUNDARY_GRADIENT : RIGHT_BOUNDARY_GRADIENT
});
